import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild
} from "@angular/core";
import { PHONE_NUMBER_VALIDATION } from "@app/shared/constants/settings.constant";
import { NgModel, FormsModule } from "@angular/forms";
import { PhoneModel } from "@app/shared/components/phone/phone.model";
import { ValidationMessageComponent } from "../validation/validation-message.component";
import { ValidationMessagesComponent } from "../validation/validation-messages.component";
import { NgxMaskModule } from "ngx-mask";
import { MatInput } from "@angular/material/input";
import { GtmChangeDirective } from "../../directives/gtm-form-event/gtm-change.directive";
import { NgIf } from "@angular/common";
import { MatFormField, MatLabel, MatError } from "@angular/material/form-field";
import { ProvideParentFormDirective } from "../../directives/provide-parent-form/provide-parent-form.directive";

@Component({
  selector: "app-phone",
  templateUrl: "./phone.component.html",
  styleUrls: ["phone.component.scss"],
  standalone: true,
  imports: [
    ProvideParentFormDirective,
    MatFormField,
    MatLabel,
    NgIf,
    GtmChangeDirective,
    MatInput,
    FormsModule,
    NgxMaskModule,
    MatError,
    ValidationMessagesComponent,
    ValidationMessageComponent
  ]
})
export class PhoneComponent {
  @Input() modelRef: PhoneModel;
  @Input() requiredField: boolean;
  @Input() redStar: boolean;
  @Input() id: string;
  @Output() focusEvent = new EventEmitter<NgModel>();
  @Output() focusoutEvent = new EventEmitter<NgModel>();
  @ViewChild("phoneNumber", { static: true }) phoneNumber: NgModel;

  phoneNumberValidation = PHONE_NUMBER_VALIDATION;

  public onFocus() {
    this.focusEvent.next(this.phoneNumber);
  }

  public onFocusOut() {
    this.focusoutEvent.next(this.phoneNumber);
  }
}
